<template>
   <div class="ui basic segment">
      <div class="ui form">
        <div class="field">
          <label>Jira URL</label>
          <input type="text" :value="$store.getters.jiraUrl" @input="setJiraUrl" placeholder="https://jira.de/">
        </div>
        <div class="field">
            <div class="ui checkbox">
              <input type="checkbox" :checked="$store.getters.askNotCommitedLogs" @input="setAskNotCommitedLogs" id="askNotCommitedLogs">
              <label for="askNotCommitedLogs">Zeige einen Dialog beim Schließen des Fenster, wenn eine Arbeitszeit nicht eingetragen wurde</label>
            </div>
        </div>
        <div class="field">
          <label>Zeige Themenvorschläge der letzten X Tage:</label>
          <input type="text" :value="$store.getters.topicSuggestionHistoryLength" @input="setTopicSuggestionHistoryLength" placeholder="30 (default)">
        </div>
        <div class="field">
          <div class="ui checkbox">
            <input type="checkbox" :checked="$store.getters.fixedStartOfWork" @input="setFixedStartOfWork" id="fixedStartOfWork">
            <label for="fixedStartOfWork">Fixer Arbeitsbeginn</label>
          </div>
        </div>
        <div class="field">
          <label>Fixe Arbeitszeit:</label>
          <TimeInput :time="toSelectedDate(startWorkTime)"
                     :disabled="!$store.getters.fixedStartOfWork"
                     @input="setStartOfWorkTime"
                     style="width: 5em;"/>
        </div>
      </div>
   </div>
</template>

<script>
import TimeInput from './TimeInput.vue'
import moment from 'moment'

export default {
        name: 'Settings',
        components: {
          TimeInput
        },
        computed: {
            startWorkTime: function () {
                return this.$store.getters.startOfWorkTime !== null ? this.$store.getters.startOfWorkTime : this.newMoment(new Date());
            }
        },
        methods: {
            newMoment: function (date) {
              let now = moment(date);
              let today = moment(this.selectedDate);

              return now.year(today.year())
                  .month(today.month())
                  .date(today.date())
                  .second(0)
                  .millisecond(0);
            },
            toSelectedDate: function (timestamp) {
              let time = moment(timestamp);
              return this.newMoment().hour(time.hour()).minute(time.minute()).valueOf();
            },
            setJiraUrl: function(event) {
                this.$store.commit('setJiraUrl', event.target.value);
            },
            setAskNotCommitedLogs: function(event) {
                this.$store.commit('setAskNotCommitedLogs', event.target.checked);
            },
            setTopicSuggestionHistoryLength: function(event) {
                if (parseInt(event.target.value) >= 0) {
                    this.$store.commit('setTopicSuggestionHistoryLength', parseInt(event.target.value));
                }
            },
            setFixedStartOfWork: function(event) {
                const fixedStartOfWork = event.target.checked;
                this.$store.commit('setFixedStartOfWork', fixedStartOfWork);
                if (fixedStartOfWork && this.$store.getters.startOfWorkTime === null) {
                  this.$store.commit('setStartOfWorkTime', this.startWorkTime);
                }
            },
            setStartOfWorkTime: function(value) {
                this.$store.commit('setStartOfWorkTime', value);
            }
        }
    }
</script>

<style scoped>
</style>
